import React, { useEffect, useRef, useState } from 'react';
import { Form, Input, Button, Alert, Switch } from 'antd';

const GroupForm = ({ initialValues, isEditMode, onFinish, onCancel, errorMessage }) => {
  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    form.resetFields();
  }, [initialValues, form]);

  const handleFinish = async (values) => {
    if (isSubmittingRef.current) return;

    isSubmittingRef.current = true;
    setIsSubmitting(true);

    try {
      await Promise.resolve(onFinish(values));
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <Form
      form={form}
      initialValues={initialValues}
      onFinish={handleFinish}
      layout="vertical"
    >
      {errorMessage && <Alert message={errorMessage} type="error" showIcon />}
      <Form.Item name="name" label="Nome" rules={[{ required: true, message: 'Por favor insira o nome' }]}>
        <Input />
      </Form.Item>
      <Form.Item name="description" label="Descrição">
        <Input.TextArea />
      </Form.Item>
      {isEditMode && (
        <Form.Item name="active" label="Ativo" valuePropName="checked">
          <Switch />
        </Form.Item>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onCancel} disabled={isSubmitting} style={{ marginRight: 8, backgroundColor: 'red', color: 'white' }}>
          Cancelar
        </Button>
        <Button type="primary" htmlType="submit" loading={isSubmitting} disabled={isSubmitting}>
          {isEditMode ? "Atualizar" : "Criar"}
        </Button>
      </div>
    </Form>
  );
};

export default GroupForm;
